import { OtpType, UseCase } from '@shopee-user/otp-hook-base-constants';
import { InitialFlow, OTP_TYPE_TO_USECASE } from './constants';

type InitialFlowConfig = {
  initialFlow: InitialFlow;
  initialUsecase: UseCase;
};

export function getInitialFlow({
  preferredChannel,
  needCaptcha,
  latestSentChannel,
  currentUseCase,
}: {
  preferredChannel: OtpType;
  needCaptcha: boolean;
  latestSentChannel?: OtpType;
  currentUseCase: UseCase;
}): InitialFlowConfig {
  const skipSendOtp = !!latestSentChannel;

  if (needCaptcha) {
    return {
      initialFlow: InitialFlow.ShowCaptcha,
      initialUsecase: currentUseCase,
    };
  }

  const targetUseCase = latestSentChannel
    ? OTP_TYPE_TO_USECASE[latestSentChannel]
    : OTP_TYPE_TO_USECASE[preferredChannel];

  if (currentUseCase !== targetUseCase) {
    return {
      initialFlow: InitialFlow.SwitchUsecase,
      initialUsecase: targetUseCase,
    };
  }

  switch (preferredChannel) {
    case OtpType.WhatsApp:
    case OtpType.Voice:
    case OtpType.Viber:
    case OtpType.Zalo:
      if (skipSendOtp) {
        return {
          initialFlow: InitialFlow.SkipSendOtp,
          initialUsecase: targetUseCase,
        };
      }
      return {
        initialFlow: InitialFlow.ShowConfirmationDialog,
        initialUsecase: targetUseCase,
      };
    case OtpType.NoChannel:
      return {
        initialFlow: InitialFlow.SelectOtpChannelInitial,
        initialUsecase: targetUseCase,
      };
    case OtpType.WhatsappAuthLink:
      return {
        initialFlow: InitialFlow.Default,
        initialUsecase: targetUseCase,
      };
    default:
      if (skipSendOtp) {
        return {
          initialFlow: InitialFlow.SkipSendOtp,
          initialUsecase: targetUseCase,
        };
      }
      return {
        initialFlow: InitialFlow.Default,
        initialUsecase: targetUseCase,
      };
  }
}
